import React from "react"
import { useLocation } from "react-router-dom"
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { haveAuth } from "utils"
import { Button } from "components"
import { tableStatusColors } from "constant"
import KtPrintQrButton from "./KtPrintQrButton"
import classes from "./index.module.scss"

const KtTableDetails = props => {
  const {
    setPage,
    tableDetails,
    setIsMounted,
    showRetrieves
  } = props

  const [t, i18n] = useTranslation()

  const location = useLocation()

  const handleChangePage = page => {
    setPage(page)

    setIsMounted(prev =>
      [
        page === "confirmed" ? true : prev[0],
        page === "unconfirmed" ? true : prev[1]
      ]
    )
  }

  const showPrintQrButton =
    location.state.previousPage === "/foods"

  const showPayCheckoutButton =
    haveAuth(["viewTableOrders"]) &&
    tableDetails.status === "busy"

  const statusLabels = {
    ready: t("آماده"),
    busy: t("اشغال_شده")
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["container"]}>
      <div className={classes["row"]}>
        <span>{t("شماره_میز")}:</span>
        <b>
          {tableDetails.tableNumber}
        </b>
      </div>
      <div className={classes["row"]}>
        <span>{t("ظرفیت")}:</span>
        <b>
          {tableDetails.capacity}
        </b>
      </div>
      <div className={classes["row"]}>
        <span>{t("وضعیت_میز")}:</span>
        <b
          style={{
            color: `var(--color-${tableStatusColors[tableDetails.status]})`
          }}
        >
          {statusLabels[tableDetails.status]}
        </b>
      </div>
      {
        showRetrieves &&
        <div
          className={clsx(classes["row"], classes["click"])}
          onClick={() => handleChangePage("unconfirmed")}
        >
          <span>{t("سفارشات_در_انتظار_تایید")}</span>

          {isLtr
            ? <FaChevronRight size={12} />
            : <FaChevronLeft size={12} />
          }
        </div>
      }
      <div className={classes["footer"]}>
        {
          showPrintQrButton &&
          <KtPrintQrButton
            tableName={tableDetails.tableNumber}
          />
        }
        {
          showPayCheckoutButton &&
          <Button
            color="success"
            className={classes["payAndCheckout"]}
            onClick={() => handleChangePage("confirmed")}

          >
            {t("پرداخت_سفارشات")}
          </Button>
        }
      </div>
    </div>
  )
}

export default KtTableDetails